<template>
	<main class="wrapper">
		<page-head>
            <el-form class="search-form" slot="left" label-width="85px">
                <x-form
                    label="书友ID"
                    v-model="searchModel.userId"
                    placeholder="输入书友ID"
                    clearable
                ></x-form>
                <x-form
                    label="昵称"
                    v-model="searchModel.nickName"
                    placeholder="输入昵称"
                    clearable
                ></x-form>
                <x-form
                    label="用户名"
                    v-model="searchModel.realName"
                    placeholder="输入用户名"
                    clearable
                ></x-form>
                <x-form
                    label="手机号"
                    v-model="searchModel.mobile"
                    placeholder="输入手机号"
                    clearable
                ></x-form>
               
                <el-button type="primary" @click="fetchList">查询</el-button>
            </el-form>
        </page-head>
		<x-table
			:tableData="tableData"
			:tableHeaders="tableHeaders"
			:total="total"
			:pageModel="pageModel"
			:fetchList="fetchList"
			:clickData="clickData"
			@clickRight="clickRight"
		></x-table>
	</main>
</template>
<script type="text/javascript">
import {
	peopleList,
	editPeople
} from '@/api/people';
export default {
	data() {
		return {
			pageModel: {
				page: 1,
				size: 20
			},
			tableData: [],
			total: 0,
			tableHeaders: [{
				headerKey: 'id',
				headerName: 'ID',
				width: 60
			}, {
				headerKey: 'avatar',
				headerName: '头像',
				image: true
			}, {
				headerKey: 'realName',
				headerName: '用户名',
			}, {
				headerKey: 'nickName',
				headerName: '昵称',
			}, {
				headerKey: 'mobile',
				headerName: '手机号',
			}, {
				headerKey: 'inviteNum',
				headerName: '邀请人数'
			}, {
				headerKey: 'signInDayNum',
				headerName: '打卡天数'
			}, {
				headerKey: 'coinNum',
				headerName: '金币数量'
			}, {
				headerKey: 'createdAt',
				headerName: '注册时间'
			}],
			searchModel: {
				userId: '',
				realName: '',
				nickName: '',
				mobile: ''
			},
			clickData: [{
				label: '禁用',
				value: 'disabled',
				color: 'red',
				rule(row) {
					return row.status != 2
				}
			}, {
				label: '启用',
				value: 'abled',
				rule(row) {
					return row.status == 2
				}
			}]
		}
	},
	methods: {
		fetchList() {
			peopleList({
				...this.pageModel,
				...this.searchModel,
				userId: Number(this.searchModel.userId)
			}).then(res => {
				this.tableData = res.data.data.users
				this.total = res.data.data.count
			})
		},
		clickRight({row, type}) {
			console.log(row, type)
			if (type == 'disabled' || type == 'abled') {
				this.$confirm(`是否${type== 'abled' ? '启用' : '禁用'}该用户`, '警告').then(res => {

					editPeople({
						uid: row.id,
						status: row.status == 2 ? 1 : 2
					}).then(res => {
						this.$message.success((type== 'abled' ? '启用' : '禁用') + '成功!')

						this.fetchList()
					})
				}).catch(err => {
					console.log(err)
				})
			}
		}
	},
	mounted() {
		this.fetchList()
	}
}
</script>

<style lang="less">
	
</style>